import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import paths from 'assets/routes/paths';

// Bug #9a (feedback app técnicos 2026-07-10): la ruta legacy
// `/specialist/lista-mantenciones/:idMantencion` (MaintanceToDo) llegaba a la
// firma del cliente SIN ningún gate de checklist — el técnico podía firmar con
// ítems pendientes y recién al finalizar el backend rechazaba (inconsistencia
// "Alto Cochrane"). Ya no hay navegación viva hacia ella; la redirigimos al
// flujo actual `/specialist/mantenciones/:id`, que sí valida estados y
// severidades antes de habilitar la firma (Mantencion.openFinish).
export default function RedirectLegacyMantencion() {
  const { idMantencion } = useParams();
  return <Navigate to={paths.specialist.mantenciones.detail(idMantencion)} replace />;
}
